import { useEffect } from 'react';
import { useRealtime } from './RealtimeProvider';

/** Ref-counted room subscription bound to component lifetime (§4.6). */
export function useRoom(room: string | null | undefined): void {
  const rt = useRealtime();
  useEffect(() => {
    if (!rt || !room) return;
    return rt.subscribe(room);
  }, [rt, room]);
}

/** Presence heartbeat every 15 s while mounted; `getPlayhead` may return null when no video is loaded. */
export function usePresenceHeartbeat(room: string | null | undefined, getPlayhead: () => { playhead_ms: number | null; version_id: string | null } | null, intervalMs = 15_000): void {
  const rt = useRealtime();
  useEffect(() => {
    if (!rt || !room) return;
    const send = () => {
      const p = getPlayhead();
      rt.presence(room, p?.playhead_ms ?? null, p?.version_id ?? null);
    };
    const t0 = setTimeout(send, 500);
    const t = setInterval(send, intervalMs);
    return () => {
      clearTimeout(t0);
      clearInterval(t);
    };
  }, [rt, room, getPlayhead, intervalMs]);
}
